<div class="modal-backdrop">
  <div class="modal-content" @fadeIn (outsideClick)="close()">
    <div class="close-button-wrapper" (click)="close()">
      <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/x.svg"></svg-icon>
    </div>
    <div>
      <svg-icon [svgStyle]="{'width.px': 242, 'height.px': 50}" src="/assets/icons/logo.svg"></svg-icon>
    </div>
    <div class="message">
      <div class="title">Web app coming soon!</div>
      <div class="content">
        <div class="text">
          In the meantime, check out our mobile app.
        </div>
        <div class="form">
          <qrcode [qrdata]="link" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
        </div>
      </div>
    </div>
  </div>
</div>
